import React, { useEffect, useState } from "react";
import { Alert, Form, Label } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { loginUser, resetLoginFlag } from "../../../slices/thunks";
import { reset_login_flag } from "../../../slices/auth/login/reducer";
import { showSuccessToast, showErrorToast } from "../../../helpers/toast_helper";
import appConfig from "../../../config";
import withRouter from "../../../Components/Common/withRouter";
import DashboardHeader from "../../../Components/Common/DashboardHeader";
import AuthLeftPanel from "../../../Components/Common/AuthLeftPanel";
import MobileInput from "../../../Components/Common/MobileInput";
import AuthFormButton from "../../../Components/Common/AuthFormButton";
import AuthLink from "../../../Components/Common/AuthLink";

const LoginPhone = (props: any) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);

  const selectLayoutState = (state: any) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    error: state.Login.error,
    errorMsg: state.Login.errorMsg,
    isLoginError: state.Login.isLoginError,
    loginSuccessMsg: state.Login.loginSuccessMsg
  }));

  const { error, isLoginError, errorMsg, loginSuccessMsg } = useSelector(loginpageData);

  useEffect(() => {
    if (loginSuccessMsg) {
      showSuccessToast(loginSuccessMsg, "login-success");
      dispatch(reset_login_flag());
    }
    if (errorMsg) {
      showErrorToast(errorMsg, "login-error");
      dispatch(reset_login_flag());
    }
  }, [loginSuccessMsg, errorMsg, dispatch]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      phoneno: '',
      countrycode: appConfig.country.defaultCountryCode,
      dialcode: appConfig.country.defaultDialCode,
      languageid: 1,
    },
    validationSchema: Yup.object({
      phoneno: Yup.string()
        .required("Please enter mobile number")
        .matches(/^[0-9]{6,10}$/, "Please enter a valid mobile number"),
      countrycode: Yup.string().required("Country code is required"),
      dialcode: Yup.string().required("Dial code is required"),
    }),
    onSubmit: (values) => {
      if (!termsAccepted) return;
      dispatch(loginUser(values, props.router.navigate));
      setLoader(true);
    },
  });

  useEffect(() => {
    if (isLoginError) {
      dispatch(resetLoginFlag());
      setLoader(false);
    }
  }, [dispatch, isLoginError]);

  document.title = "AMANAT - Login";

  return (
    <div className="auth-container">
      <DashboardHeader />
      <div className="auth-main-content">
        <div className="auth-panel-container">
          <AuthLeftPanel
            title="Login"
            description="Welcome back to AMANAT. Log in to your AMANAT account."
          />
          <div className="auth-right-panel">
            {error && <Alert color="danger" className="mb-3">{error}</Alert>}
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (!termsAccepted) return;
                validation.handleSubmit();
                return false;
              }}
              className="auth-form"
            >
              <div className="auth-form-group">
                <Label htmlFor="phoneno" className="auth-form-label">
                  Mobile number
                </Label>
                <MobileInput
                  name="phoneno"
                  value={validation.values.phoneno}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    validation.setFieldValue('phoneno', value);
                  }}
                  onBlur={validation.handleBlur}
                  dialcode={validation.values.dialcode}
                  onDialCodeChange={(dialcode, countrycode) => {
                    validation.setFieldValue('dialcode', dialcode);
                    validation.setFieldValue('countrycode', countrycode);
                  }}
                  error={validation.errors.phoneno}
                  touched={validation.touched.phoneno}
                  placeholder="Enter your mobile number"
                />
              </div>
              <div className="auth-legal-checkbox">
                <input
                  type="checkbox"
                  id="termsAccepted"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <label htmlFor="termsAccepted" className="auth-legal-text">
                  <Link
                    to="/terms-and-conditions"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Terms &amp; Conditions
                  </Link>
                  {" "}and{" "}
                  <Link
                    to="/privacy-policy"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Privacy Policy
                  </Link>
                  .
                </label>
              </div>
              <div className="auth-form-group">
                <AuthFormButton
                  loading={loader}
                  disabled={!termsAccepted}
                  type="submit"
                >
                  Request Otp
                </AuthFormButton>
              </div>
            </Form>
            <AuthLink to="/register" text="Are you a new user?" linkText="Register here" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(LoginPhone);
